<template>
  <validation-observer ref="rowDetailFormRef" novalidate tag="form">
    <div class="pt-3 pb-3 ml-2">
      <div class="row ml-1 pl-1 my-3">
        <div class="col-md-12">
          <icon-view
            icon="fas fa-user-check"
            icon-background="#fff"
            icon-color="#3dbd8c"
            icon-size="14px"
            title="Carga de Estudiante"
          />
        </div>
      </div>
      <div class="row ml-5 pl-1 my-3">
        <div class="col-md-4 col-sm-12">
          <div class="data-name mb-2">Número de SIE:</div>
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-input
              v-model="studentSieId"
              custom-error-msg=""
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
            />
            <error
              v-if="errors[0]"
              message="Favor colocar número de SIE."
              variant="no-border mt-1"
            />
          </validation-provider>
        </div>
        <div class="col-md-4 mt-4 pr-5 pt-1">
          <action-button i="fas fa-redo-alt" variant="success" @click="onSave">
            Procesar
          </action-button>
        </div>
      </div>
    </div>
  </validation-observer>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { ActionButton, CustomInput, Error } from '@/components/common';
import IconView from '@/views/provider/billingHistory/components/IconView';
import alertMixin from '@/mixins/alert.mixin';
export default {
  name: 'RowDetail',
  components: {
    ValidationObserver,
    ValidationProvider,
    ActionButton,
    CustomInput,
    IconView,
    Error,
  },
  mixins: [alertMixin],
  props: {
    model: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      studentSieId: null,
    };
  },
  methods: {
    async onSave() {
      const isValid = await this.$refs.rowDetailFormRef.validate();

      if (!isValid) {
        return;
      }

      this.model.studentSieId = this.studentSieId;
      this.$emit('on-save', this.model);
    },
  },
};
</script>
